import { getGuid } from "../App";

export const subdomain = window.location.host.split(".")[1]
  ? window.location.host.split(".")[0]
  : false;
const host = window.location.host;
class Urls {
  baseUrl() {
    return host.includes("stage.lingotalk.io") || host.includes("localhost")
      ? "https://api.stage.lingotalk.io"
      : "https://api.lingotalk.io";
  }
  static() {
    return `${this.baseUrl()}/static/`;
  }
  avatar() {
    return `${this.static()}users/avatar/`;
  }

  video() {
    return `${this.static()}teachers/video/intro/`;
  }
  resume() {
    return `${this.static()}teachers/resume/`;
  }
  api() {
    return `${this.baseUrl()}/v1/`;
  }
  UploadAvatar() {
    return `${this.api()}user/upload-avatar`;
  }
  teacherList() {
    return `${this.api()}find/teacher`;
  }
  teacherProfile(id) {
    if (id !== undefined) {
      return `${this.api()}teacher/${id}`;
    } else {
      return `${this.api()}teacher`;
    }
  }

  teacherUpdateResume() {
    return `${this.api()}teacher/resume`;
  }

  teacherCreateResume() {
    return `${this.api()}teacher/resume`;
  }

  teacherUploadIntro() {
    return `${this.api()}teacher/upload-intro`;
  }

  teacherProfileUsername(id) {
    if (id !== undefined) {
      return `${this.api()}teacher/public/${id}`;
    } else {
      return `${this.api()}teacher`;
    }
  }
  teacherProfilePublic() {}
  login() {
    return `${this.api()}login`;
  }
  Config() {
    return `${this.api()}user/config`;
  }
  AppConfig() {
    return `${this.api()}app-config`;
  }
  SendPhoneVerifyCode() {
    return `${this.api()}register/phone/send`;
  }
  SendEmailVerifyCode() {
    return `${this.api()}register/email/send`;
  }
  forgotPasswordSendPhone() {
    return `${this.api()}forgot-password/phone/send`;
  }
  forgotPasswordSendEmail() {
    return `${this.api()}forgot-password/email/send`;
  }
  updatePassword() {
    return `${this.api()}user/update-password`;
  }
  updateInfo() {
    return `${this.api()}user/update-info`;
  }
  updateSheba() {
    return `${this.api()}teacher/sheba-number`;
  }
  PhoneVerifyCode() {
    return `${this.api()}register/phone/verify`;
  }
  EmailVerifyCode() {
    return `${this.api()}register/email/verify`;
  }
  ForgotPasswordVerifyPhoneCode() {
    return `${this.api()}forgot-password/phone/verify`;
  }
  ForgotPasswordVerifyEmailCode() {
    return `${this.api()}forgot-password/email/verify`;
  }
  ForgotPassowrdPhoneUpdate() {
    return `${this.api()}forgot-password/phone/update`;
  }
  ForgotPassowrdEmailUpdate() {
    return `${this.api()}forgot-password/email/update`;
  }
  TeacherRegisterByPhone() {
    return `${this.api()}register/teacher/phone/info`;
  }
  StudentRegisterByPhone() {
    return `${this.api()}register/student/phone/info`;
  }
  StudentRegisterByEmail() {
    return `${this.api()}register/student/email/info`;
  }
  TeacherDashboardProfile() {
    return `${this.api()}teacher`;
  }
  teacherWeekly(id) {
    return `${this.teacherProfile(id)}/weekly`;
  }
  teacherResume(id) {
    return `${this.teacherProfile(id)}/resume`;
  }
  teacherReview(id) {
    return `${this.teacherProfile(id)}/reviews`;
  }
  teacherLessons(id) {
    return `${this.teacherProfile(id)}/lessons`;
  }
  teacherLessonPackage() {
    return `${this.teacherProfile()}/lesson`;
  }
  teacherPackageID(id) {
    return `${this.teacherProfile()}/lesson/package/${id}`;
  }
  teacherAvailability(id) {
    return `${this.teacherProfile(id)}/availability`;
  }
  BookLesson() {
    return `${this.api()}student/book?actionID=${getGuid()}`;
  }
  BookLessonByID(id) {
    return `${this.api()}student/book/${id}?actionID=${getGuid()}`;
  }
  CheckoutVoucher() {
    return `${this.api()}student/book/voucher`;
  }
  Payment(id) {
    return `${this.api()}user/payment/request/${id}`;
  }
  Session(role) {
    if (role === "Teacher") {
      return `${this.api()}teacher/session`;
    } else {
      return `${this.api()}student/session`;
    }
  }
  SessionJoin(id) {
    return `${this.api()}user/classroom/join/${id}`;
  }
  DemoClass() {
    return `${this.api()}teacher/class/demo`;
  }
  UserReview(SessionID) {
    return `${this.api()}student/session/${SessionID}/review`;
  }
  LingoReview(SessionID) {
    return `${this.api()}student/session/${SessionID}/video/review`;
  }
  UpcommingSession(role) {
    if (role === "Teacher") {
      return `${this.api()}teacher/session/upcoming`;
    } else {
      return `${this.api()}student/session/upcoming`;
    }
  }
  SessionStats(role) {
    return this.Session(role) + "/stats";
  }
  Wallet() {
    return `${this.api()}user/wallet`;
  }
  WalletHistory() {
    return `${this.api()}user/wallet/history`;
  }
  IncomeStats() {
    return `${this.api()}teacher/wallet/stats`;
  }
  ListTeacherAvai() {
    return `${this.api()}teacher/availability`;
  }
  WeeklyUpdate() {
    return `${this.api()}teacher/weekly`;
  }
  ReviewStats(id) {
    return `${this.api()}teacher/${id}/reviews/stats`;
  }
  LastSessionWithoutReview() {
    return `${this.api()}student/session/without-review`;
  }
  Schedule(id) {
    return `${this.api()}student/session/${id}/schedule`;
  }
  RefreshToken() {
    return `${this.api()}user/token/refresh`;
  }
  UsedTrials() {
    return `${this.api()}student/session/trial`;
  }
  Calendars() {
    return `${this.api()}user/calendars`;
  }
  TeacherSuspendSession(id) {
    return `${this.api()}teacher/session/${id}/suspend`;
  }
  TeacherScheduleSession(id) {
    return `${this.api()}teacher/session/${id}/schedule`;
  }
  TeacherRescheduleSession(id) {
    return `${this.api()}teacher/session/${id}/reschedule`;
  }
}
export default new Urls();
